export default __webpack_public_path__ + "static/media/add-blue.91dd5078.svg";